<template>
<div>
    <template v-for="item in data">
        <el-submenu v-if="item.children.length>0" :key="item.id" :index="item.id+''">

        <template slot="title">
            <i :class="item.icon"></i>
            <span :class="ind===0?'titleClass':''">{{item.catalogName}}</span>
        </template>
        <zl-sidebar1 :data="item.children" :ind="1"></zl-sidebar1>

        </el-submenu>
        <el-menu-item v-else  :key="item.id" :index="item.id+''">
        <i :class="item.icon"></i>
        <span>{{item.catalogName}}</span>
        <img class="icon_img" src="../../../static/images/study/icon/unfinished.png" alt="">
        </el-menu-item>
    </template>
</div>
</template>

<script>
export default {
    name:"zl-sidebar1",
    props:{
        data:{
            type:Array,//属性校验，为对象数据类型，并且如果没有赋值，默认给一个空对象
            default:[]
        },
        ind:{
            type:Number,
            default:0
        }
    },
    methods:{
    }
}
</script>
<style lang="scss" scoped>
.titleClass{
    font-weight: 600;
    color: #333333;
    font-size:13px;
}
/deep/ .el-menu-item{
    display: flex;
    align-items: center;
}
/deep/ .el-menu-item.is-active{
    color:#fff;
    background: #007CED;
    border-radius: 0px 0px 71px 0px;
}
.icon_img{
    width: 12px;
    height: 12px;
    position: absolute;
    right: 16px;
}
</style>




// WEBPACK FOOTER //
// src/views/component/zl-sidebar-show1.vue